/**
 *
 * @param {object} employee employee object
 * @param {object} overriddenParams
 * @param {boolean} overriddenParams.showPosition show employee position in title or not
 * @param {string} overriddenParams.titleIfEmpty title if employee is empty
 * @returns {string} formatted title
 */
export const getEmployeeTitle = (employee, overriddenParams) => {
	if(!employee || Object.keys(employee).length === 0) return null

	const params = Object.assign({
		showPosition: true,
		titleIfEmpty: null,
	}, overriddenParams)

	let title = ''
	if (employee.name) {
		title += employee.name
	}
	if (params.showPosition && employee.position) {
		title += ` (${employee.position})`
	}

	return title || params.titleIfEmpty
}
